import React from 'react';
import { NavLink } from 'react-router-dom';
import './Games.css';

const Games = () => {
  return(
    <div className="Games-page">
      <div className="side-bar">
        {/* Placeholder for ad unit - ensure proper responsive ad code after approval */}
        <div className="ad-slot" id="games-left-rail-ad" aria-label="Advertisement" />
      </div>
      <div className="Games-Container">
        <div className="games-header">
          <h1>🎮 Game Dashboard</h1>
          <p>Choose your favorite game and start playing! Our collection of free online games offers entertainment, education, and mental challenges for players of all ages.</p>
          
          <div className="games-description">
            <div className="description-grid">
              <div className="description-item">
                <span className="icon">🧠</span>
                <div>
                  <h3>Brain Training</h3>
                  <p>Exercise your mind with puzzles and logic games that improve cognitive abilities</p>
                </div>
              </div>
              <div className="description-item">
                <span className="icon">🎯</span>
                <div>
                  <h3>Skill Development</h3>
                  <p>Enhance problem-solving skills, pattern recognition, and strategic thinking</p>
                </div>
              </div>
              <div className="description-item">
                <span className="icon">🏆</span>
                <div>
                  <h3>Achievement System</h3>
                  <p>Track your progress with scores, levels, and compete on global leaderboards</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/guess-secret-number">
              <div className="professional-guess-card">
                <div className="card-background">
                  <div className="floating-numbers">
                    <span className="number-1">7</span>
                    <span className="number-2">42</span>
                    <span className="number-3">?</span>
                  </div>
                  <div className="main-icon">
                    <div className="target-icon">
                      <div className="target-ring ring-1"></div>
                      <div className="target-ring ring-2"></div>
                      <div className="target-ring ring-3"></div>
                      <div className="target-center">🎯</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Secret Number</span>
                    <span className="subtitle">Challenge Your Mind</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="brain-icon">🧠</div>
                    <div className="lightning-icon">⚡</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="game-info">
            <h3>Guess the Secret Number</h3>
            <p className="game-description">Challenge your logical thinking and mathematical skills in this engaging number deduction game. Use strategic guessing and logical reasoning to uncover the hidden number in the fewest attempts possible.</p>
            <div className="game-features">
              <span className="feature-tag">Logic</span>
              <span className="feature-tag">Mathematics</span>
              <span className="feature-tag">Strategy</span>
            </div>
          </div>
        </div>    

        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/snake-game">
              <div className="professional-snake-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">🐍</span>
                    <span className="game-element-2">🍎</span>
                    <span className="game-element-3">⚡</span>
                  </div>
                  <div className="main-icon">
                    <div className="snake-icon">
                      <div className="snake-body body-1"></div>
                      <div className="snake-body body-2"></div>
                      <div className="snake-body body-3"></div>
                      <div className="snake-head">🐍</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Snake Game</span>
                    <span className="subtitle">Classic Arcade Fun</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="score-icon">🏆</div>
                    <div className="speed-icon">💨</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>      
          <div className="game-info">
            <h3>Snake Game</h3>
            <p className="game-description">Experience the timeless classic that never gets old! Control your snake to collect food while avoiding obstacles. This arcade game improves hand-eye coordination and reaction times while providing endless entertainment.</p>
            <div className="game-features">
              <span className="feature-tag">Classic</span>
              <span className="feature-tag">Reflexes</span>
              <span className="feature-tag">Coordination</span>
            </div>
          </div>
        </div>

        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/tiger-image-shuffle-game">
              <div className="professional-tiger-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">🐅</span>
                    <span className="game-element-2">🧩</span>
                    <span className="game-element-3">⚡</span>
                  </div>
                  <div className="main-icon">
                    <div className="puzzle-icon">
                      <div className="puzzle-piece piece-1"></div>
                      <div className="puzzle-piece piece-2"></div>
                      <div className="puzzle-piece piece-3"></div>
                      <div className="puzzle-piece piece-4"></div>
                      <div className="tiger-emoji">🐅</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Tiger Puzzle</span>
                    <span className="subtitle">Arrange & Solve</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="trophy-icon">🏆</div>
                    <div className="time-icon">⏱️</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="game-info">
            <h3>Tiger Image Shuffle Game</h3>
            <p className="game-description">Reconstruct a beautiful tiger image by arranging scrambled puzzle pieces. This sliding puzzle enhances spatial reasoning, visual perception, and problem-solving abilities while showcasing stunning wildlife photography.</p>
            <div className="game-features">
              <span className="feature-tag">Puzzle</span>
              <span className="feature-tag">Visual</span>
              <span className="feature-tag">Problem Solving</span>
            </div>
          </div>
        </div> 

        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/lions-image-shuffle-game">
              <div className="professional-lions-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">🦁</span>
                    <span className="game-element-2">🧩</span>
                    <span className="game-element-3">👑</span>
                  </div>
                  <div className="main-icon">
                    <div className="puzzle-icon">
                      <div className="puzzle-piece piece-1"></div>
                      <div className="puzzle-piece piece-2"></div>
                      <div className="puzzle-piece piece-3"></div>
                      <div className="puzzle-piece piece-4"></div>
                      <div className="lion-emoji">🦁</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Lions Puzzle</span>
                    <span className="subtitle">King of Puzzles</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="crown-icon">👑</div>
                    <div className="star-icon">⭐</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="game-info">
            <h3>Lions Image Shuffle Game</h3>
            <p className="game-description">Piece together majestic lion imagery in this engaging sliding puzzle challenge. Develop pattern recognition and strategic thinking while enjoying beautiful wildlife visuals in this brain-training experience.</p>
            <div className="game-features">
              <span className="feature-tag">Puzzle</span>
              <span className="feature-tag">Pattern Recognition</span>
              <span className="feature-tag">Wildlife</span>
            </div>
          </div>
        </div>

        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/country-quiz">
              <div className="professional-quiz-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">🌍</span>
                    <span className="game-element-2">🏛️</span>
                    <span className="game-element-3">💰</span>
                  </div>
                  <div className="main-icon">
                    <div className="quiz-icon">
                      <div className="globe-ring ring-1"></div>
                      <div className="globe-ring ring-2"></div>
                      <div className="globe-center">🌍</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Country Quiz</span>
                    <span className="subtitle">Test Your Knowledge</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="trophy-icon">🏆</div>
                    <div className="brain-icon">🧠</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="game-info">
            <h3>Country Knowledge Quiz</h3>
            <p className="game-description">Challenge your global knowledge with questions about countries, capitals, and currencies. Compete on the leaderboard, build streaks, and earn time bonuses in this educational quiz adventure.</p>
            <div className="game-features">
              <span className="feature-tag">Knowledge</span>
              <span className="feature-tag">Geography</span>
              <span className="feature-tag">Competitive</span>
            </div>
          </div>
        </div> 

        <div className="game-icon">
          <div className="game-image">
            <NavLink to="/gem-quest">
              <div className="professional-gem-card">
                <div className="card-background">
                  <div className="floating-elements">
                    <span className="game-element-1">💎</span>
                    <span className="game-element-2">🔶</span>
                    <span className="game-element-3">✨</span>
                  </div>
                  <div className="main-icon">
                    <div className="gem-grid-icon">
                      <div className="gem-piece gem-1">💎</div>
                      <div className="gem-piece gem-2">🔷</div>
                      <div className="gem-piece gem-3">🟡</div>
                      <div className="gem-piece gem-4">🔴</div>
                    </div>
                  </div>
                  <div className="card-title">
                    <span className="title-text">Gem Quest</span>
                    <span className="subtitle">Jewel Match Adventure</span>
                  </div>
                  <div className="decorative-elements">
                    <div className="sparkle-icon">✨</div>
                    <div className="combo-icon">🎯</div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="game-info">
            <h3>Gem Quest - Match 3 Gems</h3>
            <p className="game-description">Embark on a sparkling adventure in this addictive match-3 puzzle game! Swap and match colorful gems to score points, create combos, and reach level targets. Features cascading matches, power-ups, and progressively challenging levels.</p>
            <div className="game-features">
              <span className="feature-tag">Match-3</span>
              <span className="feature-tag">Strategy</span>
              <span className="feature-tag">Addictive</span>
            </div>
          </div>
        </div> 
      </div>
      <div className="side-bar">
        {/* Placeholder for ad unit - ensure proper responsive ad code after approval */}
        <div className="ad-slot" id="games-right-rail-ad" aria-label="Advertisement" />
      </div>
    </div>
  );
}
export default Games;